import {
    useRouteError,
} from "react-router";

export function ErrorBoundary() {
    let error = useRouteError() as Error;
    return (
        <div className="flex flex-col items-center justify-center h-full w-full p-6">
            <img className="h-20 mb-5" src={new URL('../images/error-icon.svg', import.meta.url).toString()} alt="logo" />
            <div className="bg-pacificblue-950 p-6 rounded-lg text-white">
                <h1 className="text-orange-500 font-bold text-xl pb-4">Uh oh</h1>
                <pre>{error.message || JSON.stringify(error)}</pre>
            </div>
        </div>
    );
}